export class CacheModel {
  private _validTo: number;
  private _data: any;

  get data() {
    return this._data;
  }

  constructor(data: any, minutes: number) {
    this._data = data;
    this._validTo = !data ? 0 : this.calculateMinutes(minutes);
  }

  valid(): boolean {
    return this._validTo > Date.now();
  }

  private calculateMinutes(minutes: number): number {
    return Date.now() + minutes * 60 * 1000;
  }
}
